import React from "react";
import Image from "next/image";
import styles from "./StudentsLoanFeedBack.module.css";
import { formatDate } from "@/utils/utils";

interface Image {
  id: number;
  documentId: string;
  url: string;
  alternativeText: string;
}

interface TileDescription {
  id: number;
  title: string;
  description: string;
}

interface CardDetail {
  id: number;
  title_description: TileDescription;
  images: Image[];
}

interface Card {
  id: number;
  posted_at: string;
  card: CardDetail;
}

interface Data {
  id: number;
  title: string;
  cards: Card[];
}

interface Props {
  data: Data;
}

const StudentsLoanFeedBack: React.FC<Props> = ({ data }) => {
  const { cards, title } = data;
  return (
    <div className={styles.banner}>
      <div className="container">
        <div>
          <h2 className={styles.title}>{title}</h2>
          <div className={styles.cardContainer}>
            {cards?.map((item) => (
              <div key={item.id} className={styles.cardItem}>
                <div className={styles.profile}>
                  <Image
                    src={item?.card?.images[0]?.url}
                    alt={item?.card?.images[0]?.alternativeText}
                    title={item?.card?.images[0]?.alternativeText}
                    width={44}
                    height={44}
                  />
                  <div>
                    <p className={styles.profileName}>
                      {item?.card?.title_description?.title}
                    </p>
                    <p className={styles.date}>{formatDate(item?.posted_at)}</p>
                  </div>
                </div>
                <div>
                  <p className={styles.desc}>
                    {item?.card?.title_description?.description}
                  </p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default StudentsLoanFeedBack;
